import React, { Component } from 'react';
import brandLogo from '../images/brand-logo-image-light.png';
import { translate } from 'react-i18next';

class Footer extends Component {
  render() {
    const { t } = this.props;
    return(
      <nav className="navbar navbar-default navbar-footer" id="footer">
        <div className="container container-padding">
          <div className="navbar-header">
            <div className="navbar-brand">
              <img alt="IOS OFFICES" className="brand-logo" src={brandLogo} />
            </div>
          </div>
          <ul className="nav navbar-nav navbar-top-links">
            <li>
              <a href="https://iosfera.iosoffices.com/planes-ios-offices-contacto" rel="noopener noreferrer" target="_blank">{t('guest.footer.contact')}</a>
            </li>
            <li>
              <a href="https://www.iosoffices.com/renta-oficinas-planes" rel="noopener noreferrer" target="_blank">{t('guest.footer.services')}</a>
            </li>
            <li>
              <a href="https://www.iosoffices.com/renta-oficinas-ubicaciones" rel="noopener noreferrer" target="_blank">{t('guest.footer.locations')}</a>
            </li>
            <li>
              <a href="https://www.iosoffices.com/terminos-de-uso" rel="noopener noreferrer" target="_blank">{t('guest.footer.terms')}</a>
            </li>
          </ul>
          <ul className="nav navbar-top-links navbar-right">
            <li>
              <a href="https://www.facebook.com/iosoffices/" rel="noopener noreferrer" target="_blank">
                <i className="fa fa-fw fa-facebook" />
              </a>
            </li>
            <li>
              <a href="https://twitter.com/iosoffices/" rel="noopener noreferrer" target="_blank">
                <i className="fa fa-fw fa-twitter" />
              </a>
            </li>
            <li>
              <a href="https://www.instagram.com/iosoffices/" rel="noopener noreferrer" target="_blank">
                <i className="fa fa-fw fa-instagram" />
              </a>
            </li>
          </ul>
        </div>
      </nav>
    );
  }
}

export default translate('common')(Footer);



// WEBPACK FOOTER //
// ./src/guest/Footer.js